import { handleActions } from 'redux-actions';

import { defaultHotelList, defaultHotelData, defaultHotelMeta } from 'util/hotel';

export default handleActions(
	{
		CHANGE_HOTEL: (state, action) => ({
			...state,
			hotel: action.payload.hotel,
		}),

		FETCH_HOTEL_LIST_FULFILLED: (state, action) => ({
			...state,
			hotelList: action.payload.hotelList,
		}),

		GET_ALL_HOTEL_DATA_FULFILLED: (state, action) => ({
			...state,
			hotelData: action.payload.hotelData,
		}),
		GET_HOTEL_META_FULFILLED: (state, action) => ({
			...state,
			hotelMeta: action.payload.data,
		}),
		GET_MAIN_PAGE_META_FULFILLED: (state, action) => ({
			...state,
			mainPageMeta: action.payload.data,
		}),
	},
	{
		hotel: 'main',
		hotelList: defaultHotelList,
		hotelData: defaultHotelData,
		hotelMeta: defaultHotelMeta,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/hotel.js